var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPaymentReceived(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.957,
    height: 41.957,
    viewBox: "0 0 41.957 41.957",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33559",
    "data-name": "Group 33559",
    transform: "translate(-1577 -98)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13737",
    "data-name": "Rectangle 13737",
    width: 41.957,
    height: 41.957,
    rx: 8,
    transform: "translate(1577 98)",
    fill: "#d8fcf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "check-symbol",
    d: "M15.274,34.572a1.159,1.159,0,0,1-.822-.341L10.34,30.12a1.163,1.163,0,0,1,1.645-1.645l3.289,3.289,7.4-7.4a1.163,1.163,0,1,1,1.644,1.645L16.1,34.231A1.16,1.16,0,0,1,15.274,34.572Z",
    transform: "translate(1580.649 89.681)",
    fill: "#1eac8f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaymentReceived);
export default __webpack_public_path__ + "static/media/IconPaymentReceived.53f59dcb34b2bb97e7d78aa163ec00b0.svg";
export { ForwardRef as ReactComponent };